import React from "react";

const AboutSection = () => {

const weeks = Array.from({ length: 53 }, () => 
    Array.from({ length: 7 }, () => Math.floor(Math.random() * 5))
  );

  const months = ['Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'];

  return (
    <div>
    <section className="about-section">
      <div className="about-content">
        <h1 className="about-title">
          Know Who <span className="highlight">I'M</span>
        </h1>

        <p>
          Hi Everyone, I am <span className="purple">Shibil Khan</span> from{" "}
          <span className="purple">Karachi, Pakistan</span>.
        </p>
        <p>
          I am currently working as a <span className="purple">Frontend Developer</span>.
        </p>
        <p>
          I have hands-on experience with{" "}
          <span className="purple">React.js, Next.js, and Node.js</span>.
        </p>

        <p>I enjoy solving problems, exploring new tools, and turning ideas into fast, scalable, and intuitive web experiences that not only work great — but feel great to use.Apart from coding, some other activities that I love to do!</p>

        <ul className="about-list">
          <li>🎮 Playing Games</li>
          <li>✍️ Writing Tech Blogs</li>
          <li>✈️ Travelling</li>
        </ul>

        <p className="quote">
          "Every challenge is an opportunity to grow."
          <br />— <span className="purple">Shibil Khan</span>
        </p>
      </div>

      <div className="about-image">
        <img src="about.png" alt="About" />
      </div>
   
     
    </section>

       <div>
         <section className="skill-section" id="skills">
        <h2 className="skill-title">
          Professional <span className="highlight">Skillset</span>
        </h2>
        <div className="skill-grid">
  <div className="skill-card html"></div>
  <div className="skill-card css"></div>
  <div className="skill-card javascript"></div>
  <div className="skill-card react"></div>
  <div className="skill-card next"></div>
  <div className="skill-card tailwind"></div>
  <div className="skill-card redux"></div>
  <div className="skill-card node"></div>
  <div className="skill-card express"></div>
  <div className="skill-card mongodb"></div>
  <div className="skill-card git"></div>
  <div className="skill-card github"></div>
  <div className="skill-card firebase"></div>
  <div className="skill-card vscode"></div>  
  <div className="skill-card gsap"></div>

</div>

      </section>
    </div>

    <div className="days-container">
      <h1 className="title">
        Days I <span className="highlight">Code</span>
      </h1>

      <div className="months-row">
        {months.map((month, i) => <span key={i}>{month}</span>)}
      </div>

      <div className="calendar">
        {weeks.map((week, weekIdx) => (
          <div className="week" key={weekIdx}>
            {week.map((level, dayIdx) => (
              <div className={`day level-${level}`} key={dayIdx}></div>
            ))}
          </div>
        ))}
      </div>

      <div className="legend">
        <span>Less</span>
        <div className="colors">
          {[0, 1, 2, 3, 4].map(level => (
            <div className={`day level-${level}`} key={level}></div>
          ))}
        </div>
        <span>More</span>
      </div>

      <p className="foote1">318 contributions in the last year</p>
    </div>
    
    </div>
   
  );
};

export default AboutSection;
